import {useState} from 'react';
import {MainTab} from '../../design-system/organisms/MainTab/MainTab';
import {MainTabItemType} from '../../design-system/organisms/MainTab/MainTabItemType.interface';
import {RecentSearchesContainer} from '../../domain/search/container/RecentSearchesContainer';
import {SearchMainContainer} from '../../domain/search/container/SearchMainContainer';
import {ReactQueryFetcher} from '../../reactQuery/ReactQueryFetcher';
import {getAutoSaveRecentKeyword} from '../../recentSearchKeyword/autoSaveRecentKeyword.storage';
import {getRecentKeywordList} from '../../recentSearchKeyword/recentKeywordList.storage';
import {useSearchMainQuery} from '../../wrapper/searchWrapper';

export function PcSearchesContainer() {
  const [currentTabType, setCurrentTabType] = useState(
    getRecentKeywordList().length && getAutoSaveRecentKeyword()
      ? SearchTabType.Recent
      : SearchTabType.Popular
  );

  return (
    <div className="flex h-448pxr w-274pxr flex-col rounded-8pxr border-1 border-theme-transparent-10 shadow-[4px_6px_15px_rgba(0,0,0,0.12)]">
      <div className="px-11pxr pt-4pxr">
        <MainTab
          isMobile={true}
          tabItems={SEARCH_TAB_LIST}
          currentTabItemId={currentTabType}
          onClickTab={type => setCurrentTabType(type as number)}
          className="bg-transparent px-0"
          showBorder
        />
      </div>
      {currentTabType === SearchTabType.Recent && <RecentSearchesContainer />}
      {currentTabType === SearchTabType.Popular && (
        <ReactQueryFetcher reactQuery={useSearchMainQuery}>
          {data => <SearchMainContainer data={data} />}
        </ReactQueryFetcher>
      )}
    </div>
  );
}

enum SearchTabType {
  Recent,
  Popular,
}

const SEARCH_TAB_LIST: MainTabItemType[] = [
  {
    id: SearchTabType.Recent,
    text: '최근 검색어',
    textTKey: 'search_recent_keyword',
  },
  {
    id: SearchTabType.Popular,
    text: '인기 검색어',
    textTKey: 'search_trending',
  },
];
